import { Grid } from "@mui/material";
import React from "react";
import LeftSection from "./sections/LeftSection";
import RightSection from "./sections/RightSection";

export default function AppointmentFormPage() {
  return (
    <Grid
      container
      // spacing={2}
      height={"100vh"}
      // direction="row"
      sx={{ bgcolor: "#fafafa" }}
    >
      {/* Left Section */}
      <LeftSection />
      {/* Right Section */}
      <RightSection />
    </Grid>
  );
}
